import MuiBox, { BoxProps } from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { forwardRef } from 'react';

interface IProps extends BoxProps {
    fullWidth?: boolean;
    label?: string;
    boldLabel?: boolean;
    bordered?: boolean;
    bgWhite?: boolean;
    shadow?: boolean;
    isLoading?: boolean;
    padding?: string;
    paddingLg?: string;
    wrapperClassName?: string;
}

export const Box = forwardRef<HTMLElement, IProps>(
    (
        {
            isLoading = false,
            children,
            fullWidth,
            label,
            boldLabel = true,
            bordered = false,
            bgWhite,
            shadow,
            sx,
            padding,
            paddingLg,
            wrapperClassName = '',
            ...props
        }: IProps,
        ref
    ) => {
        const theme = useTheme();

        function renderBox() {
            return (
                <>
                    {/* {isLoading && <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 backdrop-filter backdrop-blur"><CircularProgress /></div>} */}
                    <MuiBox
                        ref={ref}
                        {...props}
                        sx={{
                            width: fullWidth ? '100%' : 'max-content',
                            height: '100%',
                            borderRadius: '12px',
                            border: bordered ? '2px solid #045F51' : 'none',
                            bgcolor: bgWhite ? 'common.white' : 'primary.100',
                            boxShadow: shadow ? '0px 4px 8px 0px #0000000F' : '',
                            [theme.breakpoints.down('lg')]: {
                                padding: padding ? padding : '20px 16px'
                            },
                            padding: paddingLg ? paddingLg : '20px 26px',
                            ...sx
                        }}
                        className={wrapperClassName}
                    >
                        {children}
                    </MuiBox>
                </>
            );
        }
        if (label) {
            return (
                <div className="flex flex-col gap-2">
                    <span className={`text-base lg:text-xl ${boldLabel && 'font-bold'}`}>{label}</span>
                    {renderBox()}
                </div>
            );
        } else {
            return renderBox();
        }
    }
);

export default Box;
